import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const fetchTours = (params = {}) =>
  api.get("/tours", { params }).then((r) => r.data);

export const fetchTour = (slug) =>
  api.get(`/tours/${slug}`).then((r) => r.data);

export const submitInquiry = (payload) =>
  api.post("/inquiries", payload).then((r) => r.data);
